// extracted by mini-css-extract-plugin
module.exports = {"IconWrapper":"Icon_IconWrapper__3uO8l"};